import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import { media } from '../../utils'

interface Props {
  start: number
  end: number
  children?: any
}

export const ProgressBar = (props: Props) => {
  const { start, end, children } = props
  return (
    <>
      <Container start={start} end={end} />
      <Nudge>{children}</Nudge>
    </>
  )
}

const SlideAnimation = (start, end) => keyframes`
  from {
    background-position: ${200 - start}% 100%;
  }
  to {
    background-position: ${200 - end}% 100%;
  }
`

const Container = styled.div`
  height: 1em;
  background: red;
  background-image: linear-gradient(to left, #974353 50%, #d5e4e6 50%);
  background-size: 200% 100%;

  animation: ${(props) => SlideAnimation(props.start, props.end)} 1s ease-in-out;
  background-position: ${(props) => 200 - props.end}% 100%;
`

const Nudge = styled.div`
  p {
    margin: 7.5px auto;
    text-align: center;
    font-size: 17px;
    color: #62d760;
    ${media.tablet`
      font-size: 15px;
    `}

    i {
      padding-right: 7.5px;
    }
  }
`

export const ProgressBarContainerWizard = styled.div`
  margin: 15px;
  margin-bottom: 0;
`

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/atoms/ProgressBar.tsx